import { get, set } from '../../store/safeLocalStorage';

/**
 * One key per user and workspace (spec §5): a shared browser does not leak one person's artist into
 * another's session, and each workspace opens on its own last artist. A token from before
 * workspaces has no licence and keeps the key of today.
 */
const keyFor = (userId: number, licenseId: number | undefined): string =>
  licenseId === undefined ? `m24ActiveAccountId:${userId}` : `m24ActiveAccountId:${userId}:${licenseId}`;

export function readActiveAccountId(userId: number, licenseId: number | undefined): number | null {
  const value = get<number>(keyFor(userId, licenseId));
  return typeof value === 'number' ? value : null;
}

export function writeActiveAccountId(userId: number, licenseId: number | undefined, accountId: number): void {
  set(keyFor(userId, licenseId), accountId);
}
